import * as React from 'react';
import { Children, useCallback, useState } from 'react';
import type { Without } from '@/types/generic';

export type UISelectProps = {
  children: any[];
  prompt: string;
  name: string;
  value?: string;
  onChange?: (value: string, label: string) => void;
} & Without<React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>, 'onChange'>;

export const UISelect =
  ({ children, prompt, name, value, onChange, ...selectProps }: UISelectProps) => {
    const [[selectedValue, selectedLabel], setSelected] = useState(['', '']);
    const handleChange = useCallback<React.SelectHTMLAttributes<HTMLSelectElement>['onChange']>((event) => {
      const [{ innerText: label, value: newValue }] = event.target.selectedOptions;
      onChange?.(newValue, label);
      if (typeof newValue !== 'undefined') setSelected([newValue, label]);
    }, [onChange, setSelected, typeof value]);

    const label = typeof value === 'undefined' ? selectedLabel : (Children.toArray(children) as any[])
      .find(({ props }) => props.value === value)?.props?.children;
    const valueToUse = typeof value === 'undefined' ? selectedValue : value;
    return (
      <div className="ui-select">
        <div id={`${name}-button`} className="ui-btn ui-icon-carat-d ui-btn-icon-right ui-corner-all ui-shadow">
          <span>{label || prompt}</span>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <select value={valueToUse} name={name} id={name} onChange={handleChange} data-role="none" {...selectProps}>
            {children}
          </select>
        </div>
      </div>
    );
  };
